export default {
  QUESTION: 'Vraag',
  QUESTION_TYPE: 'Soort vraag',
  EMPTY_OPTIONS: 'Geef a.u.b. een optiewaarde op.',
  FILL_REQUIRED_VALUES: 'Vul a.u.b. de vereiste waarden in.',
  DELETE_QUESTION_POPUP_TITLE: 'Vraag verwijderen?',
  DELETE_QUESTION_POPUP_LABEL:
    'Eenmaal verwijderd, is de vraag niet zichtbaar in de app en moet deze opnieuw worden toegevoegd voor het geval je hem terug wilt.',
  FORM_UPDATE_SUCCESS: 'Uw formulier is succesvol bijgewerkt!',
  CHOOSE_ANS_TYPE: 'Kies een antwoordtype',
  SETUP_QUESTION: 'Kwalificerende vragen instellen',
  SETUP_QUESTION_INFO: 'Wijzig deze vragen om uw leads te kwalificeren; Wijzigingen worden bijgewerkt in uw app.',
  FIX_QUESTION_INFO: 'Deze vraag is verplicht in de app en kan niet worden bewerkt of gewijzigd.',
  NEW_QUESTION_BTN: 'Klik hier om een nieuwe vraag toe te voegen'
}
